import { OrderStatus, UserOrderFlow } from '@imcc/transport';
import { Type } from 'class-transformer';
import { DONE_STATUSES } from './done-statuses';
import { OrderAsset } from './order-asset';

export class Order {
  collectionId?: string = undefined;

  downloadUrl?: string = undefined;

  flow: UserOrderFlow;

  name?: string = undefined;

  orderId?: string = undefined;

  progress = 0;

  purpose = 'Other';

  size?: number;

  @Type(() => OrderStatus)
  status?: OrderStatus = undefined;

  unit: string;

  @Type(() => OrderAsset)
  assets: OrderAsset[] = [];

  @Type(() => Date)
  completedAt?: Date = undefined;

  @Type(() => Date)
  lastModifiedAt?: Date = undefined;

  @Type(() => Date)
  createdAt?: Date = undefined;

  @Type(() => Date)
  processStartedAt?: Date = undefined;

  get isArchived() {
    return this.status === OrderStatus.archived;
  }

  get isActive() {
    return this.status !== OrderStatus.archived;
  }

  get isCompleted() {
    return this.status === OrderStatus.completed;
  }

  get isInProgress() {
    return !this.isDone;
  }

  get isDone() {
    return DONE_STATUSES.includes(this.status || OrderStatus.created);
  }

  get downloadName() {
    return `Order-${this.orderId}.zip`;
  }

  get displayName() {
    return this.name || `(${this.orderId})`;
  }
}
